import { useGetAccountByIdQuery } from "@/redux/api/accounts.rtkq";
import { useAuth } from "@/hooks/useAuth";
import { useRecordingState } from "@/contexts/RecordingStateContext";
import RecordingsTable from "@/components/audio-recording/RecordingsTable";
import FeaturePreview from "@/components/FeaturePreview";
import { canUseApp } from "@/utils/appAccess";

const RecordingsPage: React.FC = () => {
  const auth = useAuth();
  const accountId = auth.getAccountId();
  const { pendingTranscription, setPendingTranscription } = useRecordingState();

  const { data: account, isSuccess } = useGetAccountByIdQuery({ accountId: accountId! }, { skip: !accountId });

  if (!isSuccess) return null;

  if (!canUseApp(account, "recordings")) {
    return <FeaturePreview appId="recordings" />;
  }

  const isExpiredTrial = account?.subscription.status === "expired";

  return (
    <section className="h-full flex flex-col" aria-label="הקלטות">
      {/* VoiceRecorderAndUpload is rendered in MainLayout above this Outlet */}
      {/* It stays mounted to preserve recording state during navigation */}

      <div className="flex-1 flex flex-col">
        <RecordingsTable
          pendingTranscription={pendingTranscription}
          onPendingTranscriptionCleared={() => setPendingTranscription(null)}
          isReadOnly={isExpiredTrial}
        />
      </div>
    </section>
  );
};

export default RecordingsPage;
